import {
  Box,
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  IconButton,
  Typography,
} from "@mui/material";

import CloseIcon from "@mui/icons-material/Close";
import CardGiftcardIcon from "@mui/icons-material/CardGiftcard";

export default function FreePlanDialog({
  open,
  onClose,
  selectedPlan,
  onConfirm,
  loading,
}) {
  if (!selectedPlan) {
    return null;
  }

  return (
    <Dialog
      open={open}
      onClose={loading ? undefined : onClose}
      maxWidth='xs'
      fullWidth
    >
      <DialogTitle
        sx={{
          m: 0,
          p: 2,
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
          }}
        >
          <CardGiftcardIcon color='primary' />

          <Typography variant='h6' fontWeight='bold'>
            Activate Free Plan
          </Typography>
        </Box>

        <IconButton onClick={onClose} disabled={loading} size='small'>
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <Typography variant='body1' gutterBottom>
          Are you sure you want to activate the{" "}
          <strong>{selectedPlan.title}</strong>?
        </Typography>

        <Typography variant='body2' color='text.secondary' sx={{ mt: 1 }}>
          You will receive full access to all features included in the free tier
          immediately.
        </Typography>
      </DialogContent>

      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} disabled={loading} color='inherit'>
          Cancel
        </Button>

        <Button
          onClick={onConfirm}
          variant='contained'
          disabled={loading}
          sx={{
            backgroundColor: "#003D78",
            minWidth: 120,
          }}
        >
          {loading ? (
            <CircularProgress size={24} color='inherit' />
          ) : (
            "Confirm & Activate"
          )}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
